module.exports = __webpack_public_path__ + "static/img/phone-peer-review-full.4a9c665.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/phone-peer-review-full.jpg
// module id = gJEf
// module chunks = 1